import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";
import Logo from './img/logo/TC-LOGO.png';
import './MediaQuery.css';

function Footer() {
    return (
        <div className="footer">
            <div className="footer__up">
                <div className="footer__logo">
                    <Link to="/">
                        <img className="footer__l" src={Logo} alt="logo"/>
                    </Link>
                </div>
                <div className="footer__item item">
                    <h3>ABOUT US</h3>
                    <Link to="/aboutus"><label>About the Company</label></Link>
                    {/*<Link to="/terms-and-conditions"><label>terms &#38; conditions</label></Link>
                    <Link to="/privacy-policy"><label>privacy policy</label></Link>*/}
                </div>
                <div className="footer__contact">
                    <div className="footer__item item">
                        <h3 >CONTACT</h3>
                        <label>call center</label>
                        <label>+263772566468</label>
                        <label>+263778049077</label>
                        <label>email</label>
                        <label>toycityzimbabwe@gmail.com</label>
                    </div>                    
                </div>
                <div className="footer__social item">
                        <h3>GET SOCIAL</h3>
                        <div className="footer__icons footer__icon">
                            <a href='https://www.facebook.com/Toy-City-Zimbabwe-101859121847270' target='_blank' ><span className="span" class="iconify" data-icon="brandico:facebook" id='face'></span></a>
                            <a href='https://wa.me/+263772566468' target='_blank' ><span className="span" class="iconify" data-icon="akar-icons:whatsapp-fill" id='whatsapp'></span></a>
                            <a href='https://www.instagram.com/toycityzimbabwe/' target='_blank' ><span className="span" class="iconify" data-icon="brandico:instagram" id='insta'></span></a>
                            <a href='https://www.tiktok.com/@toycityzimbabwe01' target='_blank' ><span className="span" class="iconify" data-icon="cib:tiktok" id='tiktok'></span></a>
                        </div>
                    </div>
                </div>
            <div className="footer__down">
                <div className="footer__p">
                    <p>
                        Copyright © 2022-Present TOY CITY Zimbabwe. All rights reserved. All product pictures on site are property of TOY CITY Zimbabwe| Web Design &#38; Code: SDC Group. | Privacy Policy | Terms Of Service
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer;
